import router from '@/router'
import mutations from '@fps/vue-toolkit/dist/store/mutationlist'
import en from '@/translation/lang/en'
import ps from '@/translation/lang/ps'
import fa from '@/translation/lang/fa'

const locales = {en, ps, fa}

export default {
  setLanguage: ({commit}, locale) => new Promise(
    (resolve) => {
      const app = router.app

      if (app.$i18n) {
        // Load the language
        app.$i18n.setLocaleMessage(locale, locales[locale])
        // Change active locale
        app.$i18n.locale = locale

        // Change state locale
        commit(mutations.SET, {key: 'locale', value: locale})

        resolve()
      } else {
        resolve()
      }
    }
  )
};



// WEBPACK FOOTER //
// ./src/store/actions.js